import { render, staticRenderFns } from "./LoanCategory.vue?vue&type=template&id=365a9008"
import script from "./LoanCategory.vue?vue&type=script&lang=js"
export * from "./LoanCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports